import { useEffect, useState } from 'react'
import { Save } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { useToast } from '@/providers/UiProviders'
import { getRobots, saveRobots, SEO_STR as S } from './seoApi'

/**
 * A12.05 — robots.txt muharriri. Loads the current file, edits in a textarea,
 * saves via `POST /admin/seo/robots`. Dormant → empty text until it ships.
 */
export function RobotsEditorScreen() {
  const { toast } = useToast()
  const [content, setContent] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    const ac = new AbortController()
    getRobots(ac.signal).then(setContent)
    return () => ac.abort()
  }, [])

  const save = async () => {
    setBusy(true)
    try {
      await saveRobots(content)
      toast(S.saved, { tone: 'success' })
    } catch {
      toast(S.saveFailed, { tone: 'error' })
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <PageHeader
        title={S.robots}
        screenId="A12.05"
        actions={
          <button
            type="button"
            onClick={save}
            disabled={busy}
            className="inline-flex items-center gap-1.5 rounded-md bg-accent px-3 py-1.5 text-sm font-medium text-white hover:opacity-90 disabled:opacity-50"
          >
            <Save size={14} />
            {S.save}
          </button>
        }
      />
      <div className="p-4">
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          spellCheck={false}
          rows={22}
          placeholder="User-agent: *&#10;Disallow:"
          className="w-full resize-y rounded-md border border-border-default bg-surface-1 p-3 font-mono text-sm text-primary outline-none focus:border-border-strong"
        />
      </div>
    </>
  )
}
